<template>
  <!-- Page length options -->
  <section>
    <div class="card">
      <div
        v-show="onload"
        class="content bg-white"
      >
        <placeholder-content is-load="true" />
      </div>
      <div v-if="!onload && hasPermission">
        <access-denied />
      </div>
      <div
        v-show="!onload && !hasPermission"
        class="card-header bg-white header-elements-inline"
      >
        <h5 class="card-title">
          {{ $t("Total Sales Report") }}
        </h5>
      </div>
      <div
        v-show="!onload && !hasPermission"
        class="card-body"
      >
        <div class="align-items-center bg-light border-bottom d-flex flex-wrap justify-content-start mb-3 mt-n3 mx-n3 p-3">
          <!-- Date filter -->
          <span class="nowrap mr-3">{{ $t("Data Duration") }}</span>
          <div class="input-group w-auto">
            <span class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-calendar-alt" /></span>
            </span>
            <date-range-picker
              style="min-width: 175px"
              opens="right"
              :ranges="ranges"
              v-model="paramsQuery.dateRange"
              :locale-data="localedata"
              :control-container-class="'form-control rounded-left-0 rounded-right-0 border-right-0'"
              @update="applyDatePicker"
            >
              <div
                slot="input"
                v-html="showTextPicker"
              />
              <div
                slot="footer"
                slot-scope="data"
                class="p-2 drp-buttons"
              >
                <button
                  @click="cancelDateRange()"
                  v-if="!data.in_selection"
                  type="button"
                  class="applyBtn btn btn-sm btn-secondary"
                >
                  {{ $t("Cancel") }}
                </button>
                <button
                  @click="data.clickApply"
                  v-if="!data.in_selection"
                  type="button"
                  class="applyBtn btn btn-sm btn-primary"
                >
                  {{ $t("Apply") }}
                </button>
              </div>
            </date-range-picker>
          </div>
          <button
            @click="openAdvanceFilter"
            type="button"
            class="btn btn-outline-normal rounded-left-0 d-flex"
            data-toggle="modal"
            data-target="#advance_filter"
          >
            <i class="fas fa-sliders-v mr-2 mt-1" />
            {{ $t("More Filters") }}
            <span
              v-if="countFilter"
              class="badge badge-secondary ml-2"
            >{{ countFilter }}
            </span>
          </button>
          <span
            v-if="showTotalFilter"
            class="ml-2 text-blue-800"
            style="padding-top: 8px;"
          >
            {{ $t("Filters Results") }}:
            {{ totalFilter | formatNumberNotZero }}
          </span>
          <!-- \Date filter -->

          <!-- Order Status filter -->
          <!-- <span class="nowrap mx-3">{{$t("Order Status")}}</span>
                <Select2 style="min-width: 190px;max-width: 190px;" class="bg-white" v-model="paramsQuery.status" :options="orderStatusOptions" :settings="selectOptions" @change="selectStatus($event)" /> -->
          <!-- \Payment status filter -->
          <!-- <span v-if="starffOptions.length > 0" class="nowrap mx-3">{{$t("Staff")}}</span> -->
          <!-- <Select2 v-if="starffOptions.length > 0" style="min-width: 190px;max-width: 190px;" class="bg-white" v-model="paramsQuery.staff_id" :options="starffOptions" :settings="selectOptionsStaff" @change="selectStraff($event)" /> -->

          <!-- <div class="btn-group">
                    <button type="button" class="bg-white border btn btn-outline dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        <span v-if="orderStatusSelect.indexOf('ALL') !== -1">{{$t('All')}}</span>
                        <span v-else>{{orderStatusSelect.join(', ')}}</span>
                    </button>
                    <div class="dropdown-menu ">
                        <div href="#" @click="selectStatus({name: $t('All'), value: 'ALL' })" class="dropdown-item bg-light">{{$t('All')}}</div>
                        <div v-for="option in orderStatusOptions" :key="option.index" class="form-check dropdown-item">
                            <label class="form-check-label">
                                <div class="uniform-checker">
                                    <span @click="selectStatus(option)" :class="[{'checked': orderStatusSelect.includes(option.name), 'disabled': onloadPanel}]">
                                        <input type="checkbox" class="form-check-input-styled" :value="option.value" checked="checked" :disabled="onloadPanel" data-fouc="">
                                    </span>
                                </div>
                                {{$t(option.name)}}
                            </label>
                        </div>

                    </div>
                </div> -->
          <button
            @click="indicatorFunc"
            class="btn btn-primary ml-auto"
          >
            <i :class="['far  mr-2', showIndicatorOptions ? 'fa-chevron-double-up':'fa-chevron-double-down']" />{{ $t('Indicator options') }}
          </button>
        </div>
        <transition name="slide-fade">
          <div v-show="showIndicatorOptions">
            <div class="card">
              <div class="card-body d-flex">
                <span class="mr-2">{{ $t('Customer') }} :</span>
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <div class="uniform-checker">
                      <span
                        @click="checkedIndicator('customers')"
                        :class="[{'checked': selectIndicator.indexOf('customers') != -1 ? 'checked' : '' }]"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input-styled"
                          value="customers"
                          :checked="selectIndicator.indexOf('customers') != -1 ? 'checked' : ''"
                          data-fouc=""
                        >
                      </span>
                    </div>
                    {{ $t('_Report.Customers') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div
          v-if="onloadPanel"
          class="bg-white"
        >
          <placeholder-content is-load="true" />
        </div>
        <div
          v-if="!onloadPanel"
          class="d-flex flex-wrap"
        >
          <div class="card mr-3">
            <div class="card-body">
              <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3">
                <i class="fas fa-sack-dollar" />
              </span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t('_ReportTotalSales.Total Sales') }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                ฿{{ Number(reportData.card.summary.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
              </h3>
              <div class="text-grey-300">
                <span :class="['mr-1', {'text-danger': reportData.card.summary.changeFromLastMonth < 0}, {'text-green-custom': reportData.card.summary.changeFromLastMonth > 0}]">
                  <i
                    v-if="reportData.card.summary.changeFromLastMonth < 0"
                    class="fas fa-arrow-down mr-1"
                  /><i
                    v-if="reportData.card.summary.changeFromLastMonth > 0"
                    class="fas fa-arrow-up mr-1"
                  />{{ reportData.card.summary.changeFromLastMonth | formatNumber }}%
                </span> {{ $t('compared to last month') }}
              </div>
            </div>
          </div>
          <div class="card mr-3">
            <div class="card-body">
              <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3">
                <i class="fas fa-shopping-cart" />
              </span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t('_ReportTotalSales.Number of Orders') }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ Number(reportData.card.orders.total) | formatNumberAbs }}
              </h3>
              <div class="text-grey-300">
                <span :class="['mr-1', {'text-danger': reportData.card.orders.changeFromLastMonth < 0}, {'text-green-custom': reportData.card.orders.changeFromLastMonth > 0}]">
                  <i
                    v-if="reportData.card.orders.changeFromLastMonth < 0"
                    class="fas fa-arrow-down mr-1"
                  /><i
                    v-if="reportData.card.orders.changeFromLastMonth > 0"
                    class="fas fa-arrow-up mr-1"
                  />{{ reportData.card.orders.changeFromLastMonth | formatNumber }}%
                </span> {{ $t('compared to last month') }}
              </div>
            </div>
          </div>

          <div class="card mr-3">
            <div class="card-body">
              <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3">
                <i class="fas fa-box" />
              </span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t('_ReportTotalSales.Number of Products') }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ reportData.card.products.total | formatNumberAbs }}
              </h3>
              <div class="text-grey-300">
                <span :class="['mr-1', {'text-danger': reportData.card.products.changeFromLastMonth < 0}, {'text-green-custom': reportData.card.products.changeFromLastMonth > 0}]">
                  <i
                    v-if="reportData.card.products.changeFromLastMonth < 0"
                    class="fas fa-arrow-down mr-1"
                  /><i
                    v-if="reportData.card.products.changeFromLastMonth > 0"
                    class="fas fa-arrow-up mr-1"
                  />{{ reportData.card.products.changeFromLastMonth | formatNumber }}%
                </span> {{ $t('compared to last month') }}
              </div>
            </div>
          </div>

          <div class="card mr-3">
            <div class="card-body">
              <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3">
                <i class="fas fa-users" />
              </span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t('_ReportTotalSales.Number of Customers') }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ Number(reportData.card.customers.total) | formatNumberAbs }}
              </h3>
              <div class=" text-grey-300">
                <span :class="['mr-1', {'text-danger': reportData.card.customers.changeFromLastMonth < 0}, {'text-green-custom': reportData.card.customers.changeFromLastMonth > 0}]">
                  <i
                    v-if="reportData.card.customers.changeFromLastMonth < 0"
                    class="fas fa-arrow-down mr-1"
                  /><i
                    v-if="reportData.card.customers.changeFromLastMonth > 0"
                    class="fas fa-arrow-up mr-1"
                  />{{ reportData.card.customers.changeFromLastMonth | formatNumber }}%
                </span> {{ $t('compared to last month') }}
              </div>
            </div>
          </div>
        </div>
        <sales-chart
          v-if="!onloadPanel"
          :staff="staff"
          :indicator-customer-options="indicatorCustomerOptions"
        />
      </div>

      <div
        class="card"
        v-show="!onload && !onloadPanel"
      >
        <div
          :class="['table-responsive mt-0 data-nowrap table-hover table-order', loadingTable]"
          id="table-order"
        >
          <div :class="['vuetable-wrapper datatable-scroll', loading]">
            <vuetable
              ref="vuetableTotalSales"
              class="overflow-x-auto"
              :no-data-template="$t('No Data Available')"
              :fields="table.fields"
              data-path="data"
              pagination-path=""
              :api-mode="false"
              :data-manager="dataManager"
              @vuetable:loaded="vuetableLoaded"
              @vuetable:loading="vuetableLoading"
              @vuetable:pagination-data="onPaginationData"
              :sort-order="sortOrder"
            >
              <template slot="tableHeader">
                <template>
                  <tr>
                    <th
                      rowspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Order Date') }}
                    </th>
                    <th
                      rowspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Order') }}
                    </th>
                    <th
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Pending') }}
                    </th>
                    <th
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Processing') }}
                    </th>
                    <th
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Completed') }}
                    </th>
                    <th
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Returned') }}
                    </th>
                    <th
                      colspan="2"
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Canceled') }}
                    </th>
                  </tr>
          
                  <tr>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Number of Orders') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Sales') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Number of Orders') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Sales') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Number of Orders') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Sales') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Number of Orders') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Sales') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Number of Orders') }}
                    </th>
                    <th
                      class="text-center"
                    >
                      {{ $t('_ReportTotalSales.Total Sales') }}
                    </th>
                  </tr>
                </template>
              </template>
            </vuetable>
          </div>
          <div class="datatable-footer">
            <vuetable-pagination-info
              class="dataTables_info ml-3"
              ref="paginationInfo"
              :no-data-template="$t('No relevant data')"
              :info-template="$t('Displaying {from} to {to} of {total} items')"
            />
            <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
              <vuetable-pagination
                ref="pagination"
                pagination-path="pagination"
                @vuetable-pagination:change-page="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <advanceFilter
      v-if="isadvanceFilter"
      ref="advanceFilter"
      @close="isadvanceFilter = false"
    />
  </section>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import DateRangePicker from "vue2-daterange-picker";
import Select2 from "v-select2-component";
import {
    showTextPicker,
} from "../assets/directives/Vuetable.js";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import SalesChart from "./SalesChart.vue";
import moment from "moment";
import numeral from "numeral";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import fields from "../assets/js/SaleByTotalSales_fields";
import advanceFilter from "./AdvanceFilter";

export default {
    components: {
        PlaceholderContent,
        DateRangePicker,
        Select2,
        SalesChart,
        AccessDenied,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        advanceFilter,
    },
    filters: {
        formatNumber: function (value) {
            return numeral(value).format("0,0.00");
        },
        formatNumberAbs: function (value){
            return numeral(value).format("0,0");
        },
    },
    data() {
        return {
           // staff: [],
            hasPermission:true,
            showIndicatorOptions: false,
            selectIndicator: [],
            indicatorCustomerOptions: null,
            reportData: {
                card: {
                    summary: {
                        total: 0,
                        changeFromLastMonth: 0
                    },
                    orders: {
                        total: 0,
                        changeFromLastMonth: 0
                    },
                    products: {
                        total: 0,
                        changeFromLastMonth: 0
                    },
                    customers: {
                        total: 0,
                        changeFromLastMonth: 0
                    },
                },
                chart: {
                    series: [],
                    sales: [],
                    orders: [],
                    customers: [],
                }
            },
            selectOptions: {
                minimumResultsForSearch: Infinity,
            },
            onload: true,
            onloadTable: true,
            onloadPanel: true,
            paramsQuery: {
                // search: null,
                dateRange: {
                    startDate: this.$route.query.start_date != undefined ? this.$route.query.start_date : moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    endDate: this.$route.query.end_date != undefined ? this.$route.query.end_date : moment().format('YYYY-MM-DD'),
                },
                status: this.$route.query.status != undefined ? this.$route.query.status : 'ALL',
                staff_id: this.$route.query.staff_id != undefined ? this.$route.query.staff_id : 'ALL',
                order_status: ["pending", "processing", "completed"],
                payment_method_ids: [],
            },
            ranges: this.$storeIndex.ranges(),
            localedata: {
                format: "yyyy-mm-dd",
                cancelLabel: this.$t("Cancel"),
                monthNames: this.$storeIndex.monthNames(),
            },

            orderStatusOptions: [
                {
                    id: 'ALL',
                    text: this.$t('All')
                },
                {
                    id: 'UNPAID',
                    text: this.$t('Not Paid')
                },
                {
                    id: 'PARTIAL_PAID', //WAITING
                    text: this.$t('partial Paid')
                },
                {
                    id: 'PAID',
                    text: this.$t('paid')
                },
                {
                    id: 'CONFIRMED',
                    text: this.$t('Confirmed')
                },
                // {
                //     id: 'CANCELED',
                //     text: this.$t('Canceled')
                // }
            ],
            starffOptions: [{
                    id: 'ALL',
                    text: this.$t('All')
                }],
            selectOptionsStaff: {
                    placeholder: this.$t("Select Staff..."),
                    templateResult: this.formatSelect2Starff,
                    templateSelection: this.formatSelect2Starff,
                    minimumResultsForSearch: -1,
            },
            staff: null,
            loadingTable: null,
            table: {
                fields: fields,
            },
            sortOrder: [
                {
                field: "total",
                direction: "DESC"
                }
            ],
            isadvanceFilter: false,
            totalFilter: 0,
            showTotalFilter: false,
            countFilter: 0,
            reportTable: [],
            filterData: [],
            statusList: [],
            paymentMethodList: [],
            page: 1,
            perPage: 10,
            loading: 'loading',
        };
    },
    async mounted() {
        try {
            let queryString = "?getAllUser=true";
            let userData = await Api.User.getUser(queryString);
            for await(let starff of userData.data.data){
                this.starffOptions.push({
                    id: starff.id,
                    text: starff.first_name,
                    image_url: starff.image_url? starff.image_url: require('@/assets/images/no-image-user.png')
                });
            }
            const index = this.starffOptions.findIndex(starff => starff.id == this.paramsQuery.staff_id);
            this.staff = this.starffOptions[index];
        } catch(err) {
           this.starffOptions = [];
        }

        this.$router.replace({query: {
            start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.startDate), false).format('YYYY-MM-DD'),
            end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.endDate), false).format('YYYY-MM-DD'),
            // status: this.paramsQuery.status,
            // staff_id: this.paramsQuery.staff_id
        }}).catch(()=>{})
        this.filterinfo(this.paramsQuery);
        this.filterinfoTable(this.paramsQuery);
        this.countFilter =
          (this.paramsQuery.order_status.length ? 1 : 0) +
          (this.paramsQuery.payment_method_ids && this.paramsQuery.payment_method_ids.length == undefined ? 1 : 0);
    },
    watch: {
      loading() {
        // console.log("loading: ", this.loading);
      }
    },
    computed: {
        showTextPicker: function () {
            if (this.paramsQuery.dateRange.startDate && this.paramsQuery.dateRange.endDate) {
                this.paramsQuery.dateRange.startDate = convertTimezone.utcToLocal(this.paramsQuery.dateRange.startDate, false).format('YYYY-MM-DD');
                this.paramsQuery.dateRange.endDate = convertTimezone.utcToLocal(this.paramsQuery.dateRange.endDate, false).format('YYYY-MM-DD');
                this.dateTxtFilter = showTextPicker(this.paramsQuery.dateRange);
                return this.dateTxtFilter;
            } else {
                return showTextPicker(this.paramsQuery.dateRange);
            }
        }
    },
    methods: {
      changeOrderStatusOption(val) {
        this.filterinfo();
        this.filterinfoTable();
      },
      filterinfo(data = {}) {
        let queryString = ''
        let filter = {};

        filter.status = "ALL";
        filter.staff_id = "ALL";
        filter.order_status = data.order_status ? data.order_status : [];
        filter.payment_method = data.payment_method_ids ? data.payment_method_ids : [];
        filter.start_date = convertTimezone.localToUtc(moment(this.paramsQuery.dateRange.startDate).startOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
        filter.end_date = convertTimezone.localToUtc(moment(this.paramsQuery.dateRange.endDate).endOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
        
        this.paramsQuery.order_status = data.order_status ? data.order_status : [];
        this.paramsQuery.payment_method_ids = data.payment_method_ids ? data.payment_method_ids : [];
        
        if (filter) {
          queryString += '?' + $.param(filter);
        }

        this.getReportData(queryString);
      },
      filterinfoTable(data = {}) {
        let queryString = ''
        let filter = {};

        filter.status = "ALL";
        filter.staff_id = "ALL";
        filter.order_status = data.order_status ? data.order_status : [];
        filter.payment_method = data.payment_method_ids ? data.payment_method_ids : [];
        filter.start_date = convertTimezone.localToUtc(moment(this.paramsQuery.dateRange.startDate).startOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
        filter.end_date = convertTimezone.localToUtc(moment(this.paramsQuery.dateRange.endDate).endOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
        
        filter.page = this.page;
        filter.per_page = this.perPage;

        this.paramsQuery.order_status = data.order_status ? data.order_status : [];
        this.paramsQuery.payment_method_ids = data.payment_method_ids ? data.payment_method_ids : [];
        
        if (filter) {
          queryString += '?' + $.param(filter);
        }

        this.getReportDataTable(queryString);
      },
      async getReportData(queryString = '') {
          this.onload = true;
          this.onloadPanel = true;
          this.statusList = [];
          this.paymentMethodList = [];
          await Api.Report.getSalesOrderTotalSales(queryString).then((res) => {
              this.reportData = res.data;
              this.filterData = res.data.filter;
              this.hasPermission = false;
          }).catch((error) => {
            console.log("error: ", error);
              if (error.response.status === 403) {
                  this.hasPermission = true;
              }else if(error.response.status !== 403){
                  this.$router.push({name: "t.a.home"});
              } else {
                  console.log(error.response.status, 'error');
              }
          }).then(() => {
              if (this.filterData && this.filterData.order_status && this.filterData.order_status.length) {
                this.filterData.order_status.map(el => {
                  this.statusList.push({
                    id: el,
                    icon: el == "pending" ? '<i class="fa-solid fa-clock"></i>' :
                          el == "processing" ? '<i class="fas fa-sync-alt"></i>' :
                          el == "completed" ? '<i class="fas fa-check-circle"></i>' :
                          el == "returned" ? '<i class="fa-solid fa-arrow-rotate-left"></i>' :
                          '<i class="fas fa-times-square"></i>',
                    name: el == "pending" ? "_Shipment.Pending" : 
                          el == "processing" ? "Processing" :
                          el == "completed" ? "Completed" :
                          el == "returned" ? "_Order.Returned" :
                          "Cancel",
                  })
                })
              }
              if (this.filterData && this.filterData.payment_method && this.filterData.payment_method.length) {
                this.paymentMethodList = this.filterData.payment_method;
              }
          })
          // this.onload = false;
          this.onloadPanel = false;
      },
      async getReportDataTable(queryString = '') {
          this.onload = true;
          this.loadingTable = 'loading';
          await Api.Report.getSalesOrderTotalSalesTable(queryString).then((res) => {
            if (res.data && res.data.data && res.data.data.length) {
              this.reportTable = res.data;
            }
            let data = this.$storeIndex.mutations.vueTableFormatJson(res);
            data = {
              data: data.data,
              current_page: res.data.current_page,
              first_page_url: res.data.first_page_url,
              from: res.data.from,
              last_page: res.data.last_page,
              last_page_url: res.data.last_page_url,
              links: res.data.links,
              next_page_url: res.data.next_page_url,
              path: res.data.path,
              per_page: 10,
              prev_page_url: res.data.prev_page_url,
              to: res.data.to, 
              total: res.data.total,
            }
            this.$refs.vuetableTotalSales.setData(data);
            if (res.data.total) {
              // console.log(res.data);
              this.$refs.vuetableTotalSales.makePagination(res.data.total, 10);
            }
            this.hasPermission = false;
          }).catch((error) => {
            if (error.response.status === 403) {
              this.hasPermission = true;
            }else if(error.response.status !== 403){
              this.$router.push({name: "t.a.home"});
            } else {
              console.log(error.response.status, 'error');
            }
          });
          this.onload = false;
          this.loadingTable = '';
      },
      cancelDateRange() {
          $(".daterangepicker").remove();
          // this.onloadPanel = true;
          // this.page = 1;
          this.$router.replace({query: {
              start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.startDate), false).format('YYYY-MM-DD'),
              end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.endDate), false).format('YYYY-MM-DD'),
          }}).catch(()=>{})
          this.countFilter =
            (this.paramsQuery.order_status.length ? 1 : 0) +
            (this.paramsQuery.payment_method_ids && this.paramsQuery.payment_method_ids.length == undefined ? 1 : 0);
          setTimeout(() => this.onloadPanel = false , 500)
      },
      applyDatePicker(dateRange) {
          this.selectIndicator = [];
          this.paramsQuery.dateRange = dateRange;
          this.onloadPanel = true;
          this.page = 1;
          this.$router.replace({query: {
              start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.startDate), false).format('YYYY-MM-DD'),
              end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.endDate), false).format('YYYY-MM-DD'),
              // status: this.paramsQuery.status
          }}).catch(()=>{})
          let dataQuery = {
            order_status: this.paramsQuery.order_status,
            payment_method_ids: this.paramsQuery.payment_method_ids,
          }
          this.countFilter =
            (this.paramsQuery.order_status.length ? 1 : 0) +
            (this.paramsQuery.payment_method_ids && this.paramsQuery.payment_method_ids.length == undefined ? 1 : 0);
          this.filterinfo(dataQuery);
          this.filterinfoTable(dataQuery);
      },
      indicatorFunc() {
          this.showIndicatorOptions = !this.showIndicatorOptions;
      },
      checkedIndicator(val) {
          if (this.selectIndicator.includes(val)) {
              const index = this.selectIndicator.indexOf(val);
              if (index > -1) {
                  this.selectIndicator.splice(index, 1);
                  this.$cookie.remove('indicator_customers');
                  this.removeCustomerIndicator();
              }
          } else {
              this.selectIndicator.push(val);
              this.$cookie.set('indicator_customers', true);
              this.addCustomerIndicator();
          }
          // console.log('Indicator Select ---- ', this.selectIndicator)
          this.onloadPanel = false;
      },
      removeCustomerIndicator() {
          this.onloadPanel = true;
          this.indicatorCustomerOptions = '';
      },
      addCustomerIndicator() {
          this.onloadPanel = true;
          this.indicatorCustomerOptions = {
              name: this.$t('_Report.Customers'),
              type: "bar",
              symbol: "squareRatio",
              yAxisIndex: 1,
              barWidth: 20,
              barGap: 0.2,
              itemStyle: {
                  color: '#FFA726',
              },
              data: this.reportData.chart.customers,
          };
      },
      selectStatus(newStatus) {
          this.selectIndicator = [];
          this.onloadPanel = true;
          this.$router.replace({query: {
              start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.startDate), false).format('YYYY-MM-DD'),
              end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.endDate), false).format('YYYY-MM-DD'),
              status: this.paramsQuery.status = newStatus,
              staff_id: this.paramsQuery.staff_id
          }}).catch(()=>{})
          this.filterinfo();
          this.filterinfoTable();
      },
      selectStraff(newStarff) {
          this.selectIndicator = [];
          this.onloadPanel = true;
          this.$router.replace({query: {
              start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.startDate), false).format('YYYY-MM-DD'),
              end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.dateRange.endDate), false).format('YYYY-MM-DD'),
              status: this.paramsQuery.status,
              staff_id: this.paramsQuery.staff_id = newStarff
          }}).catch(()=>{})

          const index = this.starffOptions.findIndex(starff => starff.id == newStarff);
          this.staff = this.starffOptions[index];
          this.filterinfo();
          this.filterinfoTable();
      },

      formatSelect2Starff: function (starff) {
          if (!starff.id) {
              return this.$t(starff.text);
          }

          let img = '';
          if(starff.id != 'ALL'){
              img = `<img src="${starff.image_url}" class="fix-logosize image_box mr-2 rounded-circle"/>`;
          }

          let newStarffText = $(
              img+`<span  style="padding-top:2px" class="mr-2">${this.$t(starff.text)}</span>`
          );
          return newStarffText;
      },
      dataManager(sortOrder, pagination) {
        // if (this.reportTable && this.reportTable.data && this.reportTable.data.length < 1) return;
        // let local = this.reportTable.data && this.reportTable.data.length ? this.reportTable.data : [];
        // if (sortOrder.length > 0) {
        //   local = _.orderBy(
        //     local,
        //     sortOrder[0].sortField,
        //     sortOrder[0].direction
        //   );
        // }
        
        // pagination = this.$refs.vuetableTotalSales.makePagination(
        //   local.length,
        //   10
        // );
        // let from = pagination.from - 1;
        // let to = from + 10;

        // // console.log("pagination: ", pagination, this.reportTable);
        // // console.log('log:local',local);
        // return {
        //   pagination: pagination,
        //   data: _.slice(local, from, to)
        // };
        if (this.reportTable.data && this.reportTable.data.length) {
          pagination = this.$refs.vuetableTotalSales.makePagination(this.reportTable.data.length, 10);
          // console.log("pagination: ", pagination, this.reportTable);
          let from = pagination.from - 1;
          let to = from + 10;
          return {
            pagination: pagination,
            data: this.reportTable.data.slice(from, to),
          };
        }
      },
      onPaginationData(tablePagination) {
        this.$refs.pagination.setPaginationData(tablePagination);
        this.$refs.paginationInfo.setPaginationData(tablePagination);
      },
      onChangePage(page) {
        this.page = page;
        this.$refs.vuetableTotalSales.changePage(page);
        this.filterinfoTable(this.paramsQuery);
      },
      vuetableLoaded() {
        // this.onload = false;
        this.loading = '';
      },
      vuetableLoading() {
        this.loading = 'loading';
      },
      openAdvanceFilter() {
        this.isadvanceFilter = true;
        this.$nextTick(() => {
          this.isadvanceFilter = true;
        });
      },
    },
}
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
    transition: all .2s ease;
}

.slide-fade-leave-active {
    transition: all .2s;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
    {
    transform: translateY(-5px);
    opacity: 0;
}

.table thead th {
  border-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/TotalSales.vue